export const GET_ALL_USERS_DATA_REQUEST = 'GET_ALL_USERS_DATA_REQUEST';
export const GET_ALL_USERS_DATA_SUCCESS = 'GET_ALL_USERS_DATA_SUCCESS';
export const GET_ALL_USERS_DATA_FAILED = 'GET_ALL_USERS_DATA_FAILED';
export const GET_ALL_USERS_DATA_CLEAR = 'GET_ALL_USERS_DATA_CLEAR';

export const GET_USER_DATA_BY_ID_REQUEST = 'GET_USER_DATA_BY_ID_REQUEST';
export const GET_USER_DATA_BY_ID_SUCCESS = 'GET_USER_DATA_BY_ID_SUCCESS';
export const GET_USER_DATA_BY_ID_FAILED = 'GET_USER_DATA_BY_ID_FAILED';
export const GET_USER_DATA_BY_ID_CLEAR = 'GET_USER_DATA_BY_ID_CLEAR';

export const SAVE_USER_DATA_REQUEST = 'SAVE_USER_DATA_REQUEST';
export const SAVE_USER_DATA_SUCCESS = 'SAVE_USER_DATA_SUCCESS';
export const SAVE_USER_DATA_FAILED = 'SAVE_USER_DATA_FAILED';
export const SAVE_USER_DATA_CLEAR = 'SAVE_USER_DATA_CLEAR';

export const UPDATE_USER_DATA_REQUEST = 'UPDATE_USER_DATA_REQUEST';
export const UPDATE_USER_DATA_SUCCESS = 'UPDATE_USER_DATA_SUCCESS';
export const UPDATE_USER_DATA_FAILED = 'UPDATE_USER_DATA_FAILED';
export const UPDATE_USER_DATA_CLEAR = 'UPDATE_USER_DATA_CLEAR';

export const RESET_USER_PASSWORD_REQUEST = 'RESET_USER_PASSWORD_REQUEST';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';
export const RESET_USER_PASSWORD_FAILED = 'RESET_USER_PASSWORD_FAILED';
export const RESET_USER_PASSWORD_CLEAR = 'RESET_USER_PASSWORD_CLEAR';

export const GET_USER_QUEUES_DATA_REQUEST = 'GET_USER_QUEUES_DATA_REQUEST';
export const GET_USER_QUEUES_DATA_SUCCESS = 'GET_USER_QUEUES_DATA_SUCCESS';
export const GET_USER_QUEUES_DATA_FAILED = 'GET_USER_QUEUES_DATA_FAILED';
export const GET_USER_QUEUES_DATA_CLEAR = 'GET_USER_QUEUES_DATA_CLEAR';

export const REPLACE_USER_QUEUES_DATA_REQUEST =
  'REPLACE_USER_QUEUES_DATA_REQUEST';
export const REPLACE_USER_QUEUES_DATA_SUCCESS =
  'REPLACE_USER_QUEUES_DATA_SUCCESS';
export const REPLACE_USER_QUEUES_DATA_FAILED =
  'REPLACE_USER_QUEUES_DATA_FAILED';
export const REPLACE_USER_QUEUES_DATA_CLEAR = 'REPLACE_USER_QUEUES_DATA_CLEAR';

export const GET_USER_QUEUES_COUNT_DATA_REQUEST =
  'GET_USER_QUEUES_COUNT_DATA_REQUEST';
export const GET_USER_QUEUES_COUNT_DATA_SUCCESS =
  'GET_USER_QUEUES_COUNT_DATA_SUCCESS';
export const GET_USER_QUEUES_COUNT_DATA_FAILED =
  'GET_USER_QUEUES_COUNT_DATA_FAILED';
export const GET_USER_QUEUES_COUNT_DATA_CLEAR =
  'GET_USER_QUEUES_COUNT_DATA_CLEAR';

export const GET_VALIDATE_USER_QUEUES_DATA_REQUEST =
  'GET_VALIDATE_USER_QUEUES_DATA_REQUEST';
export const GET_VALIDATE_USER_QUEUES_DATA_SUCCESS =
  'GET_VALIDATE_USER_QUEUES_DATA_SUCCESS';
export const GET_VALIDATE_USER_QUEUES_DATA_FAILED =
  'GET_VALIDATE_USER_QUEUES_DATA_FAILED';
export const GET_VALIDATE_USER_QUEUES_DATA_CLEAR =
  'GET_VALIDATE_USER_QUEUES_DATA_CLEAR';

export const CHANGE_RUN_QUERY_OBJECT = 'CHANGE_RUN_QUERY_OBJECT';
export const CHANGE_RUN_QUERY_OBJECT_CLEAR = 'CHANGE_RUN_QUERY_OBJECT_CLEAR';
